import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const username = localStorage.getItem('username');
    const password = localStorage.getItem('password');

    if (username && password) {
      const basicAuth = 'Basic ' + btoa(username + ':' + password);
      request = request.clone({
        setHeaders: {
          Authorization: basicAuth
        }
      });
    }

    return next.handle(request);
  }
}
